<template>
  <div class="cardBox">
    <div class="card">
      <div class="content">
        <div class="back">
          <div class="back-content">
            <svg stroke="#ffffff" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024" height="50px" width="50px" fill="#ffffff">
              <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
              <g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M626.812121 79.127273c-134.454303 64.139636-267.884606 142.211879-400.290909 234.278788-63.084606 44.466424-113.788121 85.860848-152.048485 124.121212-19.642182 19.642182-29.478788 43.969939-29.478788 72.921212 0 27.927273 9.836606 51.727515 29.478788 71.369697l71.369697 63.612121c62.060606 48.624485 131.878788 96.721455 209.454546 144.290909 81.702788 49.648485 158.782061 93.090909 231.175757 130.327273 85.860848 42.418424 160.333576 72.921212 223.418182 91.539394 27.927273 8.285091 53.775515 5.182061 77.575758-9.309091 24.824242-13.436121 40.339394-34.133333 46.545454-62.060606 5.182061-17.594182 10.860606-43.969939 17.066667-79.127273 8.285091-49.648485 14.491152-111.709091 18.618182-186.181818l6.20606-164.460606c-2.07903-112.733091-7.230061-204.8-15.515151-276.169697-5.182061-57.933576-13.963636-109.630061-26.375758-155.151515a88.219152 88.219152 0 0 0-29.478788-49.648485 95.511273 95.511273 0 0 0-51.2-24.824243c-15.515152-2.07903-34.660848 0.527515-57.40606 7.757576-49.648485 14.491152-106.030545 36.708848-169.115152 66.715152z m-66.715151 121.018182h136.533333l4.654545 1.551515-110.157575 395.636363c-3.10303 12.412121 1.551515 18.618182 13.963636 18.618182h288.581818l-34.133333 119.466667H400.290909l153.6-529.066667c0-4.12703 2.07903-6.206061 6.206061-6.20606z">
                </path>
              </g>
            </svg>
            <strong>猎聘已支持</strong>
          </div>
        </div>
        <div class="front">
          <div class="img">
            <div class="circle">
            </div>
            <div class="circle" id="right">
            </div>
            <div class="circle" id="bottom">
            </div>
          </div>
          <div class="front-content">
            <div class="title">猎聘功能一览</div>
            <div class="desc">
              <div>职位自动刷新</div>
              <div>自动保存简历</div>
              <div>人选简历查重</div>
              <div>一键自动复聊</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>精准打招呼</div>
              <div><span style="color: #3b82f6; font-weight: bold;">AI</span>自动回复</div>
            </div>
            <div class="btn">
              <el-button @click="handGreet" size="small" plain round>立即使用</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handGreet() {
      this.$router.push({
        path: '/lpgreet'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.card {
  overflow: visible;
  width: 240px;
  height: 299px;
  box-sizing: border-box;
  user-select: none;

  .content {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 300ms;
    box-shadow: 0px 0px 10px 1px #252d3a;
    border-radius: 5px;

    .front,
    .back {
      background-color: #252d3a;
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
      border-radius: 5px;
      overflow: hidden;
    }

    .back {
      width: 100%;
      height: 100%;
      justify-content: center;
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .back::before {
      position: absolute;
      content: ' ';
      display: block;
      width: 160px;
      height: 160%;
      background: linear-gradient(90deg, transparent, #45A2FF, #45A2FF, #45A2FF, #45A2FF, transparent);
      animation: rotation_481 5000ms infinite linear;
    }

    .back-content {
      position: absolute;
      width: 99%;
      height: 99%;
      background-color: #1e2834;
      border-radius: 5px;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
    }

    .front {
      transform: rotateY(180deg);
      color: white;

      .img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;

        .circle {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background-color: #ffbb66;
          position: relative;
          filter: blur(15px);
          animation: floating 2600ms infinite linear;
        }

        #bottom {
          background-color: #ff8866;
          left: 50px;
          top: 0px;
          width: 150px;
          height: 150px;
          animation-delay: -800ms;
        }

        #right {
          background-color: #ff2233;
          left: 160px;
          top: -80px;
          width: 30px;
          height: 30px;
          animation-delay: -1800ms;
        }
      }

      .front-content {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 10px;

        .title {
          letter-spacing: 2px;
          background-color: #00000055;
          font-size: 14px;
          padding: 5px 10px;
          border-radius: 10px;
          backdrop-filter: blur(2px);
          width: fit-content;
        }

        .desc {
          letter-spacing: 2px;
          margin-top: 10px;
          padding: 10px;
          border-radius: 10px;
          background-color: #00000055;
          font-size: 14px;
          line-height: 2.1;
        }

        .btn {
          margin-top: 10px;
          text-align: center;
          cursor: pointer;

          .button {
            width: fit-content;
            display: flex;
            padding: 10px;
            cursor: pointer;
            font-weight: bold;
            border-radius: 30px;
            text-shadow: 2px 2px 3px rgb(136 0 136 / 50%);
            background: linear-gradient(15deg, #880088, #aa2068, #cc3f47, #de6f3d, #f09f33, #de6f3d, #cc3f47, #aa2068, #880088) no-repeat;
            background-size: 300%;
            color: #fff;
            border: none;
            background-position: left center;
            box-shadow: 0 30px 10px -20px rgba(0, 0, 0, .2);
            transition: background .3s ease;
          }

          .button:hover {
            background-size: 320%;
            background-position: right center;
          }
        }
      }
    }
  }
}

.card:hover .content {
  transform: rotateY(180deg);
}


@keyframes rotation_481 {
  0% {
    transform: rotateZ(0deg);
  }

  0% {
    transform: rotateZ(360deg);
  }
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>